import { XMarkIcon } from '@heroicons/react/24/outline';

import { cn } from '@/lib/utils';

export type FilterBadgeProps = {
    category?: string;
    filter?: string;
    onRemove: () => void;
    isActive?: boolean;
    canRemove?: boolean;
    className?: string;
};

export const FilterBadge: React.FC<FilterBadgeProps> = ({
    category,
    filter,
    onRemove,
    isActive = false,
    canRemove = true,
    className,
}) => {
    if (!filter) return null;

    return (
        <div
            className={cn(
                'm-w-full relative flex items-center space-x-1 truncate rounded-md border p-1 font-medium text-xs',
                isActive
                    ? 'border-blue-200 bg-blue-50 text-blue-600'
                    : 'border-blue-100 bg-neutral-50 text-neutral-800',
                className,
            )}
        >
            {!!category && (
                <span className="inline-block truncate font-normal">
                    {category} <span className="font-medium">{filter}</span>
                </span>
            )}
            {canRemove && onRemove && (
                <button onClick={onRemove}>
                    <XMarkIcon className="-ml-0.5 h-4 w-4" />
                </button>
            )}
        </div>
    );
};
